// extracted by mini-css-extract-plugin
module.exports = {"tooltip-wrapper":"style_tooltip-wrapper__29Gdb","tooltip-content":"style_tooltip-content__H-e4o"};